import React from 'react';
import cn from 'clsx';

import Typography from '../../library/typography/typography';
import { CheckSolidIcon } from '../../shared/icons/icons';

import { useMessage } from '../../shared/hooks/hooks';

import { FITMENT_OTHER_VEHICLES_OE_MESSAGE } from '../../shared/constants/messages';

import styles from './product-oe-compatible.scss';

interface ProductOECompatibleProps {
  className?: string;
}

function ProductOECompatible(props: ProductOECompatibleProps) {
  const { className = '' } = props;
  const message =
    useMessage?.[FITMENT_OTHER_VEHICLES_OE_MESSAGE] ??
    '<strong>Compatible.</strong> This is an Original Equipment Tire for another vehicle but will fit yours!';
  return (
    <div
      className={cn(styles['content'], `${className} product-oe-compatible`)}
    >
      <div className={cn(styles['block'], 'product-oe-compatible__block')}>
        <CheckSolidIcon
          className={cn(styles['icon'], 'product-oe-compatible__icon')}
        />
        <Typography
          className={cn(styles['label'], 'product-oe-compatible__label')}
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </div>
    </div>
  );
}

export default ProductOECompatible;
